module.exports = __webpack_public_path__ + "static/media/low_storage.8f0b680f.svg";